export default "__VITE_ASSET__B_cA5Txq__"